import React, { Component } from 'react';
import Layout from '../../components/Layout/Layout';
import PostbackLogsTable from '../../components/Postback/PostbackLogsTable';

class PostbackLogsPage extends Component {
  render() {
    const { match } = this.props;

    return (
      <Layout>
        <Layout.Col>
          <PostbackLogsTable match={match} />
        </Layout.Col>
      </Layout>
    );
  }
}

export default PostbackLogsPage;
